import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

function Button({ label, icon = '', type = 'button', variation = 'primary', iconOnly = false, loading = false, disabled = false, onClick }) {
  function handleClick(e) {
    if (!loading && typeof onClick === 'function') {
      onClick(e);
    }
  }

  const variationMap = {
    primary: 'main',
    geolocate: 'main geolocation-button',
  };

  const btnClasses = [
    'dealers-button',
    variationMap[variation] || variation,
    icon ? 'w-icon' : '',
    loading ? 'loading' : '',
  ].filter(Boolean).join(' ');
  return (
    <button type={type} className={btnClasses} disabled={disabled} aria-label={iconOnly ? label : null} onClick={handleClick}>
      {icon && (<Icon icon={icon} />)}
      {!iconOnly ? label : null}
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.oneOf(['submit', 'button']),
  variation: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconOnly: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Button;
